import isEqual from 'lodash-es/isEqual'
import omit from 'lodash-es/omit'

export function isSettingsFormSectionSaveAvailable({
  initialValues,
  saveIgnoredFieldNames,
  values,
}) {
  return !isEqual(
    omit(values, saveIgnoredFieldNames),
    omit(initialValues, saveIgnoredFieldNames)
  )
}
